module.exports = __webpack_public_path__ + "img/content.7c9a6374.jpg";